import React from "react";
import ComplexText from "@ui/complex-text";

const Heading = ({ data }) => (
    <h1 className="text-2xl md:text-[26px] mb-3 md:mb-5 text-skin-dark font-semibold max-w-lg">
        {data.heading}
    </h1>
);

const HeadingSmall = ({ data }) => (
    <h1 className="text-lg mb-3 md:mb-5 text-skin-dark font-semibold max-w-lg">
        {data.headingSmall}
    </h1>
);

const Subheading = ({ data }) => (
    <h2 className="md:text-xl mb-2 text-skin-dark font-semibold">
        {data.subheading}
    </h2>
);

const ComplexTextGroups = ({ data, className }) => {
    if (!data) return null;

    return data.map((values, i) => (
        <p className={`${className}${i === 0 ? " mt-0" : " mt-3"}`} key={i}>
            <ComplexText values={values} />
        </p>
    ));
};

const TextGroupWidget = ({ data }) => {
    return (
        <>
            {data.heading && <Heading data={data} />}
            {data.headingSmall && <HeadingSmall data={data} />}
            {data.subheading && <Subheading data={data} />}
            <ComplexTextGroups data={data.texts} />
            <ComplexTextGroups
                className="text-sm md:text-base"
                data={data.responsiveTexts}
            />
        </>
    );
};

export default TextGroupWidget;
